/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";
import { sectionStyle } from "@/src/components/Section/sectionStyle";
import { mergeSx } from "@/src/utils/mergeSx";

export default function Section({ children, component = "section", sx, ...boxProps }: BoxProps) {
  return (
    <Box {...boxProps} component={component} sx={mergeSx(sectionStyle.section, sx)}>
      {children}
    </Box>
  );
}
